export const objToParams = (obj: Record<string, any>): string => {
  const params = Object.keys(obj)
    .map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
    })
    .join('&');
  return params;
};
